<template>
  <div class="container">
    <el-row>
      <el-col :span="2">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="22">
        <span style="margin-left: 20px">
          <span v-if="sh_status">
            <el-button size="mini" type="success" @click="handleCheckApprove('check_yes')">审核通过</el-button>
            <el-button size="mini" type="danger" @click="handleCheckApprove('check_no')">审核不通过</el-button>
          </span>
          <span v-if="sp_status">
            <el-button size="mini" type="success" @click="handleCheckApprove('approve_yes')">审批通过</el-button>
            <el-button size="mini" type="danger" @click="handleCheckApprove('approve_no')">审批不通过</el-button>
          </span>
      </span>
        <table>
          <tr>
            <td colspan="3"><p style="font-size: 48px;text-align: center">建 筑 电 气 防 火 <br> 检 测 报 告</p>
            </td>
          </tr>
          <tr>
            <td>
              <p>项目名称：</p>
            </td>
            <td>
              <p class="font-style">{{ form.project_name }}</p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <p>委托单位：</p>
            </td>
            <td>
              <p class="font-style">{{ form.client_name }}</p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <p>项目地址：</p>
            </td>
            <td>
              <p class="font-style">{{ form.project_address }}</p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <p>检测日期：</p>
            </td>
            <td>
              <p class="font-style">{{ form.jcsj }}</p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <p>主检人员：</p>
            </td>
            <td>
              <p class="font-style">{{ form.zj }}</p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <p>审核人员：</p>
            </td>
            <td>
              <p class="font-style">{{ form.sh }}</p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <p>批准人员：</p>
            </td>
            <td>
              <p class="font-style">{{ form.sp }}</p>
            </td>
            <td></td>
          </tr>
        </table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  data() {
    return {
      site_id: '',
      project_id: '',
      employee_id: 0,
      cma_sh_id: 0,
      cma_sp_id: 0,
      site_type: '',
      rr_type: 'report',
      sh_status: false,
      sp_status: false,
      form: {
        project_name: '',
        report_code: '',
        jcsj: '',
        jcry: '',
        zj: '',
        zjrq: '',
        jly: '',
        jlyrq: '',
        sh: '',
        shrq: '',
      }
    }
  },
  methods: {
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_all_sh_spers', {
          project_id: this.project_id,
          site_id: this.site_id
        })
        if (res) {
          res.forEach(item => {
            if (item.cma_sh_id) {
              this.cma_sh_id = item.cma_sh_id
            }
            if (item.cma_sp_id) {
              this.cma_sp_id = item.cma_sp_id
            }
          })
          let res2 = await this.$Api.post('get_site_status', {
            project_id: this.project_id,
            site_id: this.site_id,
            site_type: this.site_type,
            status_type: 'cma'
          })
          console.log(this.employee_id)
          console.log(this.cma_sp_id)
          console.log(this.cma_sh_id)
          console.log(res2)
          if (res2) {
            if (res2 === '审核中' && this.employee_id === this.cma_sh_id) {
              this.sh_status = true
            } else if (res2 === '审批中' && this.employee_id === this.cma_sp_id) {
              this.sp_status = true
            } else {
              this.sh_status = false
              this.sp_status = false
            }
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //审核审批
    async handleCheckApprove(opt) {
      try {
        await this.$Api.post('check_approve', {
          opt_type: opt,
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          cma_zg: 'cma'
        })
        this.$message.success('操作成功')
        location.reload()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async getRecord() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
        }
        this.form = await this.$Api.post('get_record_cma_index', params)
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    async handleSubmit() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        await this.$Api.post('edit_record_cma_index', params)
        await this.getRecord()
        this.$message.success('修改成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.employee_id = Vue.$Config.userinfo.employee_id
    this.setButtonStatus()
    this.getRecord();
  }
}
</script>
<style scoped>
table {
  width: 100%;
}

table tr td:first-child {
  width: 20%;
}

table td {
  text-align: right;
  font-size: 22px;
}

.font-style {
  text-align: left;
  text-decoration: underline;
}

</style>
